export const TAG_TYPE_DISCOUNT = 'DISCOUNT'
export const TAG_TYPE_ACTIVITY = 'ACTIVITY'

export const immutableTags = [TAG_TYPE_ACTIVITY, TAG_TYPE_DISCOUNT];
